import ContactInfo from './models';

export const state = {
  info: new ContactInfo(),
};

export const mutations = {
  clearContactForm(state) {
    state.info.init();
  },
};